export default __webpack_public_path__ + "static/media/k.eed10564.svg";